<template>
  <div class="step-line-container" @click="clickStepLine">
    <div
      v-if="stepItemData.step"
      class="step-text"
      :style="{
        background: returnApplicationItem(stepItemData).background,
        color: returnApplicationItem(stepItemData).color,
      }"
    >
      {{ stepItemData.step }}
    </div>
    <div class="step-title">{{ stepItemData.title }}</div>
  </div>
</template>
<script>
import { APPLICATION_STATUSES } from './const.js';
export default {
  name: 'StepLine',
  props: {
    stepItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      applicationStatuses: APPLICATION_STATUSES,
    };
  },
  methods: {
    returnApplicationItem(step) {
      const applicationItem = this.applicationStatuses.find((item) => item.value === step.step);
      if (!applicationItem) return {};
      return applicationItem;
    },
    clickStepLine() {
      this.$emit('clickStepLine', this.stepItemData);
    },
  },
};
</script>
<style lang="scss" scoped>
.step-line-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;
  .step-text {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 18px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 6px;
  }
  .step-title {
    color: #84909d;
    font-size: 12px;
    font-weight: 400;
    display: -webkit-box; /* Flex 容器 */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    overflow: hidden; /* 超出隐藏 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    -webkit-line-clamp: 1; /* 限制显示行数 */
  }
}
</style>
